import React from "react";

import { Box, Checkbox, Paper, styled, Typography } from "@mui/material";
import { Switch, useMantineTheme } from "@mantine/core";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
type Props = {
  offer: any;
  onDecision: (data: any) => void;
  type: string;
  insurance: any;
  subTitle: string;
  price: number;
  koalaIdx: any;
  checkedIns: boolean;
};

const CheckInCard = ({
  offer,
  onDecision,
  type,
  insurance,
  subTitle,
  price,
  koalaIdx,
  checkedIns,
}: Props) => {
  const theme = useMantineTheme();
  const [checked, setChecked] = React.useState(checkedIns);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);

    const dataToPass = {
      bundle: insurance,
      index: koalaIdx,
      status: event.target.checked,
    };
    onDecision(dataToPass);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginBottom: "25px",
        padding: "5px 10px",
        zIndex: "5",
      }}>
      <Paper
        sx={{
          display: "flex",
          justifyContent: "space-between",
          minHeight: "75px",
          borderRadius: "1px",
          boxShadow: "0px 0px 5px 0px",
        }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}>
          <Checkbox
            sx={{
              minWidth: "20px",
              minHeight: "20px",
            }}
            value={checked}
            checked={checked}
            onChange={(val) => handleChange(val)}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}>
            <span>{insurance.bundle}</span>
            <Typography variant="body1">
              <span
                style={{
                  color: "#73798c",
                  fontSize: "14px",
                  marginRight: "2px",
                }}>
                {subTitle}
              </span>
              <span
                style={{
                  fontSize: "12px",
                }}>
                Read more
              </span>
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}>
          <span
            style={{
              color: "#809fff	",
            }}>
            + €{price}/pers
          </span>
          <Switch
            style={{
              marginRight: "10px",
              borderRadius: "15px",
            }}
            size="lg"
            color={theme.colorScheme === "dark" ? "gray" : "teal"}
            onLabel={
              <SentimentVerySatisfiedIcon
                style={{
                  color: theme.colors.yellow[4],
                  width: "16",
                  stroke: "2.5",
                }}
              />
            }
            offLabel={
              <SentimentVeryDissatisfiedIcon
                style={{
                  color: theme.colors.blue[6],
                  width: "16",
                  stroke: "2.5",
                }}
              />
            }
            defaultChecked={checked}
            checked={checked}
            onChange={(val) => handleChange(val)}
          />
        </Box>
      </Paper>
      <Box
        sx={{
          height: "15px",
          background: "#ffe4c4",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "15px",
        }}>
        <h3
          style={{
            marginLeft: "30px",
            color: "#ff8c00",
            fontSize: "12px",
          }}>
          Applies for only the current travelers.
        </h3>
      </Box>
    </Box>
  );
};

export default CheckInCard;
